import flatpickr from 'flatpickr';
import { Ja } from 'flatpickr/dist/l10n/ja.js';
import monthSelectPlugin from 'flatpickr/dist/plugins/monthSelect';
import { onConnect } from '@sonicgarden/onconnect';
import { formatDateJa } from '../lib/formatDateJa';

const addDate = function addDate(date) {
  const year = date.getFullYear();
  const month = 1 + date.getMonth();
  const day = date.getDate();

  const dateStrJa = formatDateJa(date);
  const dateStr = `${year}/${month}/${day}`;

  const $div = $(`<div><strong>${dateStrJa}</strong> <a href="#" class="fa-fw link-unstyled js-delete-date-of-use"><i class="fa fa-trash"></i></a><input type="hidden" value="${dateStr}" name="request[dates][]" /></div>`);
  $('.js-date-of-use-list').append($div);
};

onConnect('.js-flatpickr-clear', (element) => {
  const onClick = () => {
    const input = element.closest('.input-group').querySelector('.js-flatpickr');
    if (input && input._flatpickr) {
      input._flatpickr.clear();
    }
  };

  element.addEventListener('click', onClick);
  return () => {
    element.removeEventListener('click', onClick);
  };
});

onConnect('.js-flatpickr', (element) => {
  const fp = flatpickr(element, {
    dateFormat: 'Y-m-d',
    locale: 'ja',
    disableMobile: true,
  });

  if (element.dataset.flatpickerOpened === 'true') {
    fp.open();
  }
});

onConnect('.js-flatpickr-future', (element) => {
  flatpickr(element, {
    dateFormat: 'Y-m-d',
    minDate: new Date().fp_incr(1),
    locale: 'ja',
    disableMobile: true,
  });
});

onConnect('.js-flatpickr-month', (element) => {
  flatpickr(element, {
    dateFormat: 'Y/m',
    locale: 'ja',
    // NOTE: モバイルではflatpickrが元のinputと同じclassを持つネイティブ入力を複製挿入するため、
    //       onConnectが複製にも反応して初期化が無限ループする。他の.js-flatpickr系と同様に無効化する
    disableMobile: true,
    plugins: [
      new monthSelectPlugin({
        shorthand: true, // defaults to false
        dateFormat: 'Y/m', // defaults to "F Y"
        altFormat: 'Y/m', // defaults to "F Y"
        theme: 'light', // defaults to "light"
      }),
    ],
  });
});

onConnect('.js-request-date-of-use', (element) => {
  element.addEventListener('click', (e) => {
    e.preventDefault();
  });

  flatpickr(element, {
    dateFormat: 'Y-m-d',
    minDate: new Date(),
    locale: 'ja',
    disableMobile: true,
    onChange: (selectedDates, dateStr, instance) => {
      addDate(selectedDates[0]);
    },
  });
});

$(document).on('click', '.js-delete-date-of-use', function (e) {
  $(this).parent().remove();
  e.preventDefault();
});
